var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IFRAME',{attrs:{"width":"100%","height":"1200px","src":_vm.URL}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }